<template>
  <div>
    <v-card
      flat
      class="pa-3"
      :class = "this.cardClass()"
    >
      <v-card-text class="pa-0 title black--text">
        <mrx-translation :token="panelText"></mrx-translation>

        <p class="display-1 black--text pt-4 text-center" v-for="(date,i) in dates" :key="i">
          {{ $d(date, 'short') }}
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import ui from '@/mixins/ui'

  export default {
    mixins: [ui],
    name: 'duedatedisplay',
    model: {
      prop: 'items',
      event: 'click'
    },
    data() {
      return {
        dates: [],
      }
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String
    },
    methods: {
      setInitial() {
        let dates = this.options.startDate.map((cur, index) => {
          let start = cur === 'today' ? new Date() : new Date(this.$store.getters['v4/panel/getResponse'](cur, 'date').value)
          return new Date(start.setDate(start.getDate() + this.options.addDays[index]))
        })
        this.dates = dates

        this.items[0].value = this.options.startDate.length > 1 ?
          dates.map(d => d.toISOString().slice(0, 10)) :
          dates[0].toISOString().slice(0, 10)
        this.items[0].selected = true
      }
    },
    computed: {
      panelText() {
        return `questions.${this.panelName}.text`
      }
    },
    mounted() {
      this.setInitial()
    },
    watch: {
      panelName: function() {
        this.setInitial()
      }
    }
  }
</script>
